<div id="wt">
  <button type="button" class="close text-primary m-2" aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
    <i class="fas fa-times-circle"></i>
  </button>
  <div class="modal-header d-flex justify-content-center border-bottom-0">
    <div>
      <h5 class="modal-title">Devolver Requerimiento</h5>
    </div>
  </div>
  <div class="modal-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-group">

      <div class="form-group offset-2 col-8">
        <label for="commentArea">Comentario</label>
        <textarea class="form-control" id="commentArea" rows="3" formControlName="commentArea"></textarea>
      </div>

      <div class="modal-footer border-top-0 justify-content-center">
        <button type="submit" class="btn btn-outline-primary bg-white rounded-pill text-dark font-weight-bold" style="width: 120px" [disabled]="returning">
          @if (returning) {
            <div>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Cargando...
            </div>
          }
          @if (!returning) {
            <span>Devolver</span>
          }
        </button>
      </div>
    </form>
  </div>
</div>